import React, { useState } from 'react';
import axios from 'axios';

const TestApiFranceTravail = () => {
  const [searchType, setSearchType] = useState('rome');
  const [searchValue, setSearchValue] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (type, value) => {
    if (!value.trim()) {
      setError('Veuillez entrer une valeur de recherche');
      return;
    }

    setLoading(true);
    setError(null);
    setResults(null);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'http://localhost:3002/api/france-travail/test-api',
        {
          searchType: type,
          searchValue: value
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setResults(response.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e, type) => {
    e.preventDefault();
    handleSearch(type, searchValue);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h1 style={{
          color: 'white',
          textAlign: 'center',
          marginBottom: '30px',
          fontSize: '2.5em',
          textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
        }}>
          🔍 Test API France Travail
        </h1>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
          marginBottom: '30px'
        }}>
          {/* Bloc recherche par code ROME */}
          <div style={{
            background: 'white',
            padding: '25px',
            borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            transition: 'transform 0.3s ease'
          }}>
            <h2 style={{
              color: '#667eea',
              marginBottom: '20px',
              fontSize: '1.5em',
              borderBottom: '3px solid #667eea',
              paddingBottom: '10px'
            }}>
              🎯 Recherche par Code ROME
            </h2>
            <form onSubmit={(e) => handleSubmit(e, 'rome')}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '5px',
                  color: '#333',
                  fontWeight: '600'
                }}>
                  Code ROME (ex: M1805)
                </label>
                <input
                  type="text"
                  value={searchType === 'rome' ? searchValue : ''}
                  onChange={(e) => {
                    setSearchType('rome');
                    setSearchValue(e.target.value);
                  }}
                  placeholder="M1805"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1
                }}
              >
                {loading && searchType === 'rome' ? 'Recherche...' : 'Rechercher'}
              </button>
            </form>
          </div>

          {/* Bloc recherche par code RNCP */}
          <div style={{
            background: 'white',
            padding: '25px',
            borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            transition: 'transform 0.3s ease'
          }}>
            <h2 style={{
              color: '#667eea',
              marginBottom: '20px',
              fontSize: '1.5em',
              borderBottom: '3px solid #667eea',
              paddingBottom: '10px'
            }}>
              📜 Recherche par Code RNCP
            </h2>
            <form onSubmit={(e) => handleSubmit(e, 'rncp')}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '5px',
                  color: '#333',
                  fontWeight: '600'
                }}>
                  Numéro de Fiche RNCP (ex: RNCP34947)
                </label>
                <input
                  type="text"
                  value={searchType === 'rncp' ? searchValue : ''}
                  onChange={(e) => {
                    setSearchType('rncp');
                    setSearchValue(e.target.value);
                  }}
                  placeholder="RNCP34947"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1
                }}
              >
                {loading && searchType === 'rncp' ? 'Recherche...' : 'Rechercher'}
              </button>
            </form>
          </div>

          {/* Bloc recherche par intitulé */}
          <div style={{
            background: 'white',
            padding: '25px',
            borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            transition: 'transform 0.3s ease'
          }}>
            <h2 style={{
              color: '#667eea',
              marginBottom: '20px',
              fontSize: '1.5em',
              borderBottom: '3px solid #667eea',
              paddingBottom: '10px'
            }}>
              💼 Recherche par Intitulé
            </h2>
            <form onSubmit={(e) => handleSubmit(e, 'intitule')}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '5px',
                  color: '#333',
                  fontWeight: '600'
                }}>
                  Intitulé de métier ou formation
                </label>
                <input
                  type="text"
                  value={searchType === 'intitule' ? searchValue : ''}
                  onChange={(e) => {
                    setSearchType('intitule');
                    setSearchValue(e.target.value);
                  }}
                  placeholder="Développeur web"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1
                }}
              >
                {loading && searchType === 'intitule' ? 'Recherche...' : 'Rechercher'}
              </button>
            </form>
          </div>
        </div>

        {/* Résultats */}
        {error && (
          <div style={{
            background: '#fee',
            color: '#c33',
            padding: '15px',
            borderRadius: '8px',
            borderLeft: '4px solid #c33',
            marginBottom: '20px'
          }}>
            ⚠️ {error}
          </div>
        )}

        {results && (
          <div style={{
            background: 'white',
            padding: '30px',
            borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
          }}>
            <h2 style={{
              color: '#667eea',
              marginBottom: '20px',
              fontSize: '2em',
              borderBottom: '3px solid #667eea',
              paddingBottom: '10px'
            }}>
              📊 Résultats de la recherche
            </h2>

            <div style={{
              background: '#efe',
              color: '#3c3',
              padding: '15px',
              borderRadius: '8px',
              borderLeft: '4px solid #3c3',
              marginBottom: '20px'
            }}>
              ✅ Recherche effectuée avec succès (Type: {results.searchType.toUpperCase()})
            </div>

            {results.data.matchInfo && (
              <div style={{
                background: '#e3f2fd',
                borderLeft: '4px solid #2196f3',
                padding: '15px',
                marginBottom: '20px',
                borderRadius: '5px'
              }}>
                <strong style={{ color: '#1976d2' }}>Correspondance trouvée:</strong><br />
                Numéro Fiche: {results.data.matchInfo.numeroFiche || 'N/A'}<br />
                Code ROME: {results.data.matchInfo.codeRome || 'N/A'}
              </div>
            )}

            {results.data.ficheMetier && (
              <div style={{
                marginBottom: '30px',
                padding: '20px',
                background: '#f9f9f9',
                borderRadius: '10px',
                borderLeft: '4px solid #667eea'
              }}>
                <h3 style={{
                  color: '#764ba2',
                  marginBottom: '15px',
                  fontSize: '1.3em'
                }}>
                  📋 Fiche Métier ROME
                </h3>
                <pre style={{
                  background: '#2d2d2d',
                  color: '#f8f8f2',
                  padding: '20px',
                  borderRadius: '8px',
                  overflow: 'auto',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  maxHeight: '400px'
                }}>
                  {JSON.stringify(results.data.ficheMetier, null, 2)}
                </pre>
              </div>
            )}

            {results.data.fichesMetiers && results.data.fichesMetiers.length > 0 && (
              <div style={{
                marginBottom: '30px',
                padding: '20px',
                background: '#f9f9f9',
                borderRadius: '10px',
                borderLeft: '4px solid #667eea'
              }}>
                <h3 style={{
                  color: '#764ba2',
                  marginBottom: '15px',
                  fontSize: '1.3em'
                }}>
                  📋 Fiches Métiers ROME ({results.data.fichesMetiers.length})
                </h3>
                {results.data.fichesMetiers.map((fiche, index) => (
                  <div key={index} style={{ marginBottom: '20px' }}>
                    <h4>Fiche #{index + 1} - {fiche.metier?.libelle || 'N/A'}</h4>
                    <pre style={{
                      background: '#2d2d2d',
                      color: '#f8f8f2',
                      padding: '20px',
                      borderRadius: '8px',
                      overflow: 'auto',
                      fontSize: '14px',
                      lineHeight: '1.5',
                      maxHeight: '400px'
                    }}>
                      {JSON.stringify(fiche, null, 2)}
                    </pre>
                  </div>
                ))}
              </div>
            )}

            {results.data.competences && results.data.competences.length > 0 && (
              <div style={{
                marginBottom: '30px',
                padding: '20px',
                background: '#f9f9f9',
                borderRadius: '10px',
                borderLeft: '4px solid #667eea'
              }}>
                <h3 style={{
                  color: '#764ba2',
                  marginBottom: '15px',
                  fontSize: '1.3em'
                }}>
                  💡 Compétences Détaillées ({results.data.competences.length})
                </h3>
                <pre style={{
                  background: '#2d2d2d',
                  color: '#f8f8f2',
                  padding: '20px',
                  borderRadius: '8px',
                  overflow: 'auto',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  maxHeight: '400px'
                }}>
                  {JSON.stringify(results.data.competences, null, 2)}
                </pre>
              </div>
            )}

            {results.data.codesRome && results.data.codesRome.length > 0 && (
              <div style={{
                marginBottom: '30px',
                padding: '20px',
                background: '#f9f9f9',
                borderRadius: '10px',
                borderLeft: '4px solid #667eea'
              }}>
                <h3 style={{
                  color: '#764ba2',
                  marginBottom: '15px',
                  fontSize: '1.3em'
                }}>
                  🏷️ Codes ROME associés
                </h3>
                {results.data.codesRome.map((code, index) => (
                  <span
                    key={index}
                    style={{
                      display: 'inline-block',
                      padding: '5px 10px',
                      background: '#667eea',
                      color: 'white',
                      borderRadius: '5px',
                      fontSize: '12px',
                      marginRight: '5px',
                      marginBottom: '5px'
                    }}
                  >
                    {code}
                  </span>
                ))}
              </div>
            )}

            {results.data.numerosFiches && results.data.numerosFiches.length > 0 && (
              <div style={{
                marginBottom: '30px',
                padding: '20px',
                background: '#f9f9f9',
                borderRadius: '10px',
                borderLeft: '4px solid #667eea'
              }}>
                <h3 style={{
                  color: '#764ba2',
                  marginBottom: '15px',
                  fontSize: '1.3em'
                }}>
                  🎓 Numéros de Fiches RNCP ({results.data.numerosFiches.length})
                </h3>
                {results.data.numerosFiches.map((num, index) => (
                  <span
                    key={index}
                    style={{
                      display: 'inline-block',
                      padding: '5px 10px',
                      background: '#667eea',
                      color: 'white',
                      borderRadius: '5px',
                      fontSize: '12px',
                      marginRight: '5px',
                      marginBottom: '5px'
                    }}
                  >
                    {num}
                  </span>
                ))}
              </div>
            )}

            {results.data.blocsCompetences && results.data.blocsCompetences.length > 0 && (
              <div style={{
                marginBottom: '30px',
                padding: '20px',
                background: '#f9f9f9',
                borderRadius: '10px',
                borderLeft: '4px solid #667eea'
              }}>
                <h3 style={{
                  color: '#764ba2',
                  marginBottom: '15px',
                  fontSize: '1.3em'
                }}>
                  🧩 Blocs de Compétences RNCP ({results.data.blocsCompetences.length})
                </h3>
                <pre style={{
                  background: '#2d2d2d',
                  color: '#f8f8f2',
                  padding: '20px',
                  borderRadius: '8px',
                  overflow: 'auto',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  maxHeight: '400px'
                }}>
                  {JSON.stringify(results.data.blocsCompetences, null, 2)}
                </pre>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TestApiFranceTravail;
